module.exports = __webpack_public_path__ + "img/dstv.4130e248.svg";